import React from 'react';
import { useTranslation } from 'react-i18next';

import DropdownComponent from 'legacy/common/components/dropdown/Dropdown';
import { useFriendRequestCommandsForGuestList } from 'legacy/user/hooks';
import { EventGuest } from '../../../../../types';
import { connect } from 'react-redux';
import {
  getReceivedFriendRequests,
  getSentFriendRequests
} from '../../../../../../actions/friendActions';

type Props = {
  getReceivedFriendRequests: () => void;
  getSentFriendRequests: () => void;
  guest: EventGuest;
  friendRequestCommands: ReturnType<
    typeof useFriendRequestCommandsForGuestList
  >;
};

const FriendActions = ({
  guest,
  friendRequestCommands,
  getSentFriendRequests,
  getReceivedFriendRequests
}: Props) => {
  const { t } = useTranslation(['users', 'common']);
  const {
    sendFriendRequestCommand,
    cancelFriendRequestCommand,
    acceptFriendRequestCommand,
    declineFriendRequestCommand,
    removeFriendCommand
  } = friendRequestCommands;

  const onFriendActionSuccess = () => {
    getSentFriendRequests();
    getReceivedFriendRequests();
  };

  const onAddFriend = () => {
    sendFriendRequestCommand.mutate(guest.id, {
      onSuccess: onFriendActionSuccess
    });
  };

  const onCancelFriendRequest = () => {
    cancelFriendRequestCommand.mutate(guest.id, {
      onSuccess: onFriendActionSuccess
    });
  };

  const onAcceptFriendRequest = () => {
    acceptFriendRequestCommand.mutate(guest.id, {
      onSuccess: onFriendActionSuccess
    });
  };

  const onDeclineFriendRequest = () => {
    declineFriendRequestCommand.mutate(guest.id, {
      onSuccess: onFriendActionSuccess
    });
  };

  const onRemoveFriend = () => {
    removeFriendCommand.mutate(guest.id, {
      onSuccess: onFriendActionSuccess
    });
  };

  if (guest.friendStatus === 'friends' || guest.friendStatus === 'fbFriends') {
    return (
      <DropdownComponent
        label={t('users:friends')}
        items={[
          {
            label: (
              <span className="text-red-500">
                {t('common:buttons.unfriend')}
              </span>
            ),
            onClick: onRemoveFriend
          }
        ]}
      />
    );
  }

  if (guest.friendStatus === 'requestSent') {
    return (
      <button
        type="button"
        onClick={onCancelFriendRequest}
        className="w-full overflow-hidden font-bold text-sm text-center text-ellipsis whitespace-nowrap text-red-400"
      >
        {t('common:buttons.cancelRequest')}
      </button>
    );
  }

  if (guest.friendStatus === 'requestReceived') {
    return (
      <DropdownComponent
        label="Respond"
        items={[
          {
            label: (
              <span className="text-primary-400">
                {t('common:buttons.accept')}
              </span>
            ),
            onClick: onAcceptFriendRequest
          },
          {
            label: (
              <span className="text-red-500">
                {t('common:buttons.decline')}
              </span>
            ),
            onClick: onDeclineFriendRequest
          }
        ]}
      />
    );
  }

  if (guest.friendStatus === 'requestable') {
    return (
      <button
        type="button"
        onClick={onAddFriend}
        className="w-full overflow-hidden text-base font-bold text-center text-ellipsis whitespace-nowrap text-primary-400"
      >
        {t('common:buttons.addFriend')}
      </button>
    );
  }

  return null;
};

export default connect((props) => ({ ...props }), {
  getSentFriendRequests,
  getReceivedFriendRequests
})(FriendActions);
